module.exports = __webpack_public_path__ + "components/home-header/static/header-6--large@2x-ca02c5ce8959068ab7fbdb325041848f.jpg";